<template>
    <div>
        <div class="rules-banner" v-if="getExpert">
            <!--<button type="button" @click="joinEvent('0')">{{user.firstName}}</button>-->
            <!--<button type="button" @click="joinEvent('1')">Shoecognito</button>-->
            <!--<button type="button" @click="joinEvent('0')">{{user.firstName}}</button>-->
            <!--<button type="button" @click="joinEvent('1')">Shoe-cognito</button>-->
            <div v-if="getSelectedEvent">
            <div v-if="isEventToday(getSelectedEvent[0].start_date, getSelectedEvent[0].end_date)">
                <!--<div v-if="isEventToday(getSelectedEvent[0].start_date) === false">-->
                <h2>Hey, {{user.firstName}}. Welcome to our community of women helping women, featuring TONE Talks moderated discussions and TONE Live streaming events with our experts.
                    <br>How you would like to join the conversation?
                </h2>
            <button type="button" @click="joinEvent('0')">{{user.firstName}}</button>
            <button type="button" @click="joinEvent('1')">Shoe-cognito</button>
            </div>
            <div v-else>
                <h2>Hey, {{user.firstName}}. Welcome to our community of women helping women, featuring TONE Talks moderated discussions and TONE Live streaming events with our experts.
                </h2>
                <h2>Event will start here at <br> {{getDateReference(getSelectedEvent[0].start_date, 'live2')}}</h2>
            </div>
            </div>
        </div>
        <div class="talkRulesHeading">
            <h2>Events Guidelines</h2>
        </div>
        <div class="container">
            <div class="row marginTop rulerow">
                <div class="col-sm-3">
                    <div class="ruleImages">
                        <img src="../assets/rule-one.jpg" alt="">
                        <p>
                            Keep it positive, supportive and respectful.
                        </p>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="ruleImages">
                        <img src="../assets/rule-two.jpg" alt="">
                        <p>
                            Please be thoughtful and stay on topic.
                        </p>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="ruleImages">
                        <img src="../assets/rule-three.jpg" alt="">
                        <p>
                            Please do not post copyrighted material, ads, solicitations or anyone's personal info including your own.
                        </p>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="ruleImages">
                        <img src="../assets/rule-four.jpg" alt="">
                        <p>
                            Please refer to TONE's <a href="/terms">Terms of Service</a> for more information.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="rules-expert-content" v-if="getExpert">
                    <h2>about the expert</h2>
                    <img v-bind:src="getExpert[0].small_image" alt="">
                    <h4>{{getExpert[0].name}}</h4>
                    <h5>{{getExpert[0].experties}}</h5>
                    <p  v-html="getExpert[0].biography">
                        <!--{{getExpert[0].biography}}-->
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { dateHelpers } from '../helpers/dateHelpers.js'
    export default {
        name: 'Rules',
        metaInfo () {
            return {
                title: 'TONE | Event Rules',
                meta: [
                    {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {property: 'og:title', content: 'TONE | Event Rules'},
                    {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                    {
                        property: 'og:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'twitter:title', content: 'TONE | Event Rules'},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                    {
                        property: 'twitter:description',
                        content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                event: '',
                userEvent: '',
                seatReservation: {
                    userEventId: 0,
                    eventId: 0,
                    userId: 0,
                    status: 2,
                    isAnonymous: 0
                }
            }
        },
        methods: {
            joinEvent (isAnonymous) {
                this.updateUserStatus(isAnonymous)
                if (this.getSelectedEvent) {
                    if (this.getSelectedEvent[0].type === '1') { // Live Event
                        if (isAnonymous === '1') {
                            setTimeout(() => {
                                this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {
                                    if (this.getUserEvents) {
                                        let uEvent = this.getUserEvents.filter(ev => {
                                            return ev.eventId === this.getSelectedEvent[0].eventId
                                        })
                                        uEvent[0].isAnonymous = '1'
                                        uEvent[0].firstName = 'Shoe-cognito'
                                        this.$store.dispatch('GENERATESIGNATUREWITHEVENT', uEvent[0]).then(() => {
                                            if (this.getUserSignature) {
                                                this.$router.push(`/liveevent/` + this.getSelectedEvent[0].eventId)
                                            }
                                        })
                                    }
                                })
                            }, 500)
                        } else {
                            this.$store.dispatch('GENERATESIGNATURE', this.user.userId).then(() => {
                                if (this.getUserSignature) {
                                    this.$router.push(`/liveevent/` + this.getSelectedEvent[0].eventId)
                                }
                            })
                        }
                    } else {
                        if (isAnonymous === '1') { // Talk Event
                            setTimeout(() => {
                                this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {
                                    if (this.getUserEvents) {
                                        let uEvent = this.getUserEvents.filter(ev => {
                                            return ev.eventId === this.getSelectedEvent[0].eventId
                                        })
                                        uEvent[0].isAnonymous = '1'
                                        uEvent[0].firstName = 'Shoe-cognito'
                                        this.$store.dispatch('GENERATESIGNATUREWITHEVENT', uEvent[0]).then(() => {
                                            if (this.getUserSignature) {
                                                this.$router.push(`/talk/` + this.getSelectedEvent[0].eventId)
                                            }
                                        })
                                    }
                                })
                            }, 500)
                        } else {
                            this.$store.dispatch('GENERATESIGNATURE', this.user.userId).then(() => {
                                if (this.getUserSignature) {
                                    this.$router.push(`/talk/` + this.getSelectedEvent[0].eventId)
                                }
                            })
                        }
                    }
                }
            },
            returnEasternTime () {
                let offset = -5
                if (dateHelpers.dstEnabled(new Date())) {
                    offset = -4.0
                }
                let clientDate = new Date()
                let utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000)
                let serverDate = new Date(utc + (3600000 * offset))
                return serverDate
            },
            getDateReference (dte, type) {
                let dt = new Date(dte)
                let dayStr, monStr
                let eDay = dt.getDate()
                let eHours = this.getHoursFormatted(dt)
                let eMonth = dt.getMonth() + 1
                let day
                // Set Day of Date
                if (dt.getDay() === 0) {
                    day = 'Sunday'
                } else if (dt.getDay() === 1) {
                    day = 'Monday'
                } else if (dt.getDay() === 2) {
                    day = 'Tuesday'
                } else if (dt.getDay() === 3) {
                    day = 'Wednesday'
                } else if (dt.getDay() === 4) {
                    day = 'Thursday'
                } else if (dt.getDay() === 5) {
                    day = 'Friday'
                } else if (dt.getDay() === 6) {
                    day = 'Saturday'
                } else {
                    day = ''
                }
                // Set Date Pattern
                if (eDay === 1) {
                    dayStr = '1st'
                } else if (eDay === 2) {
                    dayStr = '2nd'
                } else if (eDay === 3) {
                    dayStr = '3rd'
                } else if (eDay === 21) {
                    dayStr = '21st'
                } else if (eDay === 22) {
                    dayStr = '22nd'
                } else if (eDay === 23) {
                    dayStr = '23rd'
                } else if (eDay === 31) {
                    dayStr = '31st'
                } else {
                    dayStr = eDay + 'th'
                }
                // Set Month
                if (eMonth === 1) {
                    monStr = 'January'
                } else if (eMonth === 2) {
                    monStr = 'February'
                } else if (eMonth === 3) {
                    monStr = 'March'
                } else if (eMonth === 4) {
                    monStr = 'April'
                } else if (eMonth === 5) {
                    monStr = 'May'
                } else if (eMonth === 6) {
                    monStr = 'June'
                } else if (eMonth === 7) {
                    monStr = 'July'
                } else if (eMonth === 8) {
                    monStr = 'August'
                } else if (eMonth === 9) {
                    monStr = 'September'
                } else if (eMonth === 10) {
                    monStr = 'October'
                } else if (eMonth === 11) {
                    monStr = 'November'
                } else if (eMonth === 12) {
                    monStr = 'December'
                }
                if (type === 'btn') {
                    return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!'
                } else if (type === 'live') {
                    return monStr + ' ' + eDay
                } else if (type === 'live2') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else if (type === 'str') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else {
                    return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET'
                }
            },
            isEventToday (evtDate, endDate) {
                let eventDate = new Date(evtDate)
                let currentDate = this.returnEasternTime()
                let eventEndDate = new Date(endDate)
                // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
                if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                    if (this.getMinutesBetweenDates(currentDate, eventDate) <= 15 && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            getMinutesBetweenDates (startDate, endDate) {
                var diff = endDate.getTime() - startDate.getTime()
                return (diff / 60000)
            },
            updateUserStatus (status) {
                // Get event from User Events
                this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {
                    if (this.getUserEvents) {
                        let uEvent = this.getUserEvents.filter(ev => {
                            return ev.eventId === this.getSelectedEvent[0].eventId
                        })
                        if (uEvent && uEvent.length > 0) {
                            this.seatReservation.eventId = this.getSelectedEvent[0].eventId
                            this.seatReservation.userId = this.user.userId
                            this.seatReservation.status = '2'
                            this.seatReservation.isAnonymous = status
                            this.seatReservation.userEventId = uEvent[0].userEventId
                            this.$store.dispatch('UPDATERESERVATION', this.seatReservation).then(() => {
                            })
                        } else {
                            this.seatReservation.eventId = this.getSelectedEvent[0].eventId
                            this.seatReservation.userId = this.user.userId
                            this.seatReservation.status = '2'
                            this.seatReservation.isAnonymous = status
                            this.$store.dispatch('SEATRESERVATION', this.seatReservation).then(() => {
                            })
                        }
                    }
                })
            },
            getHoursFormatted (time) {
                let hours = time.getHours()
                let minutes = time.getMinutes()
                let ampm = hours >= 12 ? 'pm' : 'am'
                hours = hours % 12
                hours = hours === 0 ? '12' : hours
                minutes = minutes < 10 ? '0' + minutes : minutes
                let strTime = hours + ':' + minutes + ' ' + ampm
                return strTime
            }
        },
        mounted: function () {
            let self = this
            if (self.$route.params.eventId) {
                self.$router.push(`/event/${self.$route.params.eventId}`)
            } else {
                self.$router.push('/event')
            }
//            if (this.getTrialDays < 0) {
//                this.$router.push('/becomemember')
//            } else {
//                if (this.$route.params.eventId > 0) {
//                    this.$store.dispatch('GETSELECTEDEVENT', this.$route.params.eventId).then(() => {
//                        if (this.getSelectedEvent) {
//                            this.$store.dispatch('GETEXPERT', this.getSelectedEvent[0].expertId).then(() => {
//                            })
//                            this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {})
//                        } else {
//                            this.$router.push(`/events`)
//                        }
//                    })
//                } else {
//                    this.$router.push(`/events`)
//                }
//            }
        },
        computed: {
            ...mapGetters([
                'user', 'getExpert', 'getSelectedEvent', 'getUserEvents', 'getUserSignature', 'getUserStatus', 'getTrialDays']
            )
        }
    }
</script>

<style scoped>
    .container .rules-expert-content img {
        width: 160px;
        height: 160px;
        display: block;
        margin: 0 auto 25px;
        border-radius: 50%;
    }
    .container .marginTop .ruleImages p {
        text-align: left;
        color: #000000;
        font-family: sans-serif;
        padding: 0 0 0 30px;
        line-height: 1.2;
        margin: 0;
        position: absolute;
    }
    @media(min-width:993px){
    .rules-banner{
        height: auto;
        min-height: 582px;
        padding-bottom: 80px;
    }
    }
</style>



// WEBPACK FOOTER //
// Rules.vue?0602b3cc